// @vendors
const Immutable = require('immutable');
const get = require('lodash/object/get');

// @constants
const {
    BROKER_MIFID_PRODUCTS_FETCH,
    BROKER_MIFID_PRODUCTS_FETCH_SUCCESS,
    BROKER_MIFID_PRODUCTS_FETCH_FAILURE
} = require('constants/actionTypes');

const INITIAL_STATE = Immutable.fromJS({
    products: {}
});

/**
 * @param {Immutable.Map} immState
 * @param {String} productId
 * @returns {Immutable.Map}
 */
const fetchProduct = (immState, productId) => {
    return immState.setIn(['products', productId], Immutable.fromJS({ loading: true, fetched: false }));
};

/**
 * @param {Immutable.Map} immState
 * @param {String} productId
 * @param {Object} response
 * @returns {Immutable.Map}
 */
const fetchSuccessProduct = (immState, productId, response) => {
    const immProduct = immState.getIn(['products', productId]);
    const disclaimer =
        get(response, 'disclaimer.disclaimer') ||
        get(response, 'disclaimer') ||
        '';
    const codigoDisclaimer = get(response, 'disclaimer.codigoDisclaimer') || '';

    return immState.setIn(
        ['products', productId],
        immProduct.set('loading', false)
                  .set('fetched', true)
                  .merge(Immutable.fromJS(response))
                  .set('disclaimer', disclaimer)
                  .set('codigoDisclaimer', codigoDisclaimer)
                  .set('date', response.fecha || '')
                  .set('requiresTest', response.necesitadTest === 'S')
                  .set('motive', response.motivo)
    );
};

/**
 * @param {Immutable.Map} immState
 * @param {String} productId
 * @param {Object} error
 * @returns {Immutable.Map}
 */
const fetchFailureProduct = (immState, productId, error) => {
    const immProduct = immState.getIn(['products', productId]);
    return immState.setIn(
        ['products', productId],
        immProduct.set('loading', false).set('fetched', true).set('error', Immutable.fromJS(error))
    );
};

/**
 * @param {Immutable.Map} state,
 * @param {Object} action
 */
function brokerMiFIDProductsReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case BROKER_MIFID_PRODUCTS_FETCH:
            return fetchProduct(state, action.payload.productId);
        case BROKER_MIFID_PRODUCTS_FETCH_SUCCESS:
            return fetchSuccessProduct(state, action.payload.productId, action.payload.response);
        case BROKER_MIFID_PRODUCTS_FETCH_FAILURE:
            return fetchFailureProduct(state, action.payload.productId, action.payload.error);
        default:
            return state;
    }
}

module.exports = brokerMiFIDProductsReducer;
